<mat-card class="card profile-card">
    <mat-card-content>
        <p i18n class="mat-card-header">CUSTOMER ADDRESS</p>
        <div class="card-content">
            <div class="avatar-pad">
                <div class="img-avatar" style="width:100%">
                    <img [src]="avatar" id="profilePreview" alt="avatar" class="avatar">
                    <img [src]="profileUrl" />
                </div>
                <div class="btn-group">
                    <button i18n id="avatar" (click)="imageProcess()">Upload an image</button>
                </div>
            </div>
            <div class="detail">
                <form [formGroup]="profileForm" (ngSubmit)="updateProfile()">
                    <div class="item" style="font-weight: bold;">
                        <label i18n for="userId">User ID: </label>
                        {{userId}}
                    </div>
                    <div *ngIf="inWizard">
                        <p i18n class="bold">Info:</p>
                        <p i18n class="wizard-info">
                            Here you fill in your details, please note that first name, last name, and country are
                            mandatory.
                            You can also add a profile picture for a personal touch. You can easily modify or add
                            information to
                            your profile under "Profile" in the menu.
                        </p>
                    </div>
                    <div class="item">
                        <label i18n for="firstName">First name <span style="color:red">*</span></label>
                        <input type="text" id="firstName" formControlName="firstName">
                        <div *ngIf="firstName.errors?.['required']" style="color:red">
                            <p i18n>Firstname is required.</p>
                        </div>
                    </div>
                    <div class="item">
                        <label i18n for="lastName">Last name <span style="color:red">*</span></label>
                        <input type="text" id="lastName" formControlName="lastName">
                        <div *ngIf="lastName.errors?.['required']" style="color:red">
                            <p i18n>Lastname is required.</p>
                        </div>
                    </div>
                    <div class="item">
                        <label i18n for="address">Address</label>
                        <input type="text" id="address" formControlName="address">
                    </div>
                    <div class="item">
                        <label i18n for="zipcode">Zip/Postal Code</label>
                        <input type="text" id="zipcode" formControlName="zipcode">
                    </div>
                    <div class="item">
                        <label i18n for="city">City</label>
                        <input type="text" id="city" formControlName="city">
                    </div>
                    <div class="item">
                        <label i18n for="country">Country <span style="color:red">*</span></label>
                        <select formControlName="country">
                            <option i18n *ngFor="let item of countries" [value]="item.country">{{item.country}}
                            </option>
                        </select>
                        <div *ngIf="country.errors?.['required']" style="color:red">
                            <p i18n>Country is required.</p>
                        </div>
                    </div>
                    <div class="item" *ngIf="selectedCountry.province.length >= 1">
                        <label i18n for="province">Province/State <span style="color:red">*</span></label>
                        <select formControlName="province">
                            <option i18n *ngFor="let item of provinces" [value]="item.name">{{item.name}}
                            </option>
                        </select>
                    </div>
                    <div class="item">
                        <label i18n for="phone">Phone Number</label>
                        <input type="text" id="phone" formControlName="phone">
                    </div>
                    <div class="item">
                        <label i18n for="company">Company</label>
                        <input type="text" id="company" formControlName="company">
                    </div>
                    <div class="item">
                        <label i18n for="vat">VAT Number</label>
                        <input type="text" id="vat" formControlName="vat">
                    </div>
                    <div class="item">
                        <div class="disclamer-text">
                            <p i18n>We will not publish or in any way disclose your data or Gedcom files, without your
                                consent.Please note that the consent does not apply to whether we may process your data,
                                but
                                only to
                                publication in our web system or website.</p>
                            <a href="https://ancytree.com/privacy-policy/" target="_blank" i18n>Read more about how we
                                process your
                                data in our Privacy Policy</a>
                        </div>
                        <button i18n type="submit" value="Update address" id="btn" [disabled]="" class="submit-btn">
                            Save profile
                        </button>
                    </div>
                </form>

            </div>
        </div>
    </mat-card-content>
</mat-card>